import { createSlice } from "@reduxjs/toolkit";

const emptyItem = { account: "", amount: "", remarks: "", qty: "", vehicle_no: "", hp_number: "" };

export const accountPaymentSlice = createSlice({
  name: "accountPayment",
  initialState: {
    loading: false,
    list: [],
    model: false,
    viewModel: false,
    viewData: {},
    drawer: false,
    listCount: 0,
    error_msg: null,
    rowdata: { items: [{ ...emptyItem }], deletedItems: [] },
    params: {
      start_date: "",
      end_date: "",
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
      counter: "",
      division: "",
      state: "",
    },
  },
  reducers: {
    getList: (state) => ({ ...state, loading: true }),
    listSuccessful: (state, action) => ({
      ...state,
      listCount: action.payload.response.count,
      list: action.payload.response.results,
      loading: false,
      params: {
        ...state.params,
        no_of_pages: Math.ceil(action.payload.response.count / state.params.page_size),
      },
    }),
    addRecord: (state) => ({ ...state, loading: true }),
    addRecordSuccessful: (state) => ({
      ...state,
      loading: false,
      model: false,
      rowdata: { items: [{ ...emptyItem }], deletedItems: [] },
    }),
    editRecord: (state, action) => ({
      ...state,
      model: true,
      rowdata: {
        id: action.payload.id,
        items: [{ ...emptyItem }],
        deletedItems: [],
      },
    }),
    viewRecord: (state, action) => ({
      ...state,
      viewModel: true,
      viewData: action.payload,
    }),
    isViewModelVisible: (state, action) => ({
      ...state,
      viewModel: action.payload,
      ...(!action.payload && { viewData: {} }),
    }),
    getRecordById: (state) => ({ ...state, loading: true }),
    getRecordByIdSuccessful: (state, action) => {
      const apiItems = action.payload.accountpaymentitems || action.payload.ccditems || [];
      const items = apiItems.length
        ? apiItems.map((item) => ({
            ...item,
            account: item.customer?.id || item.customer || item.expense_account?.id || item.expense_account_id || item.expense_choice || item.account || "",
            customer_code: item.customer?.code || item.customer_code || "",
            vehicle_no: item.vehicle_no?.id || item.vehicle_no_id || "",
            hp_number: item.hp_number || "",
          }))
        : [{ ...emptyItem }];
      return {
        ...state,
        loading: false,
        rowdata: {
          id: action.payload.id,
          doc_no: action.payload.doc_no || action.payload.code,
          date: action.payload.date,
          cash_bank_ac: action.payload.cash_bank_ac,
          counter_id: action.payload.counter?.id,
          state_id: action.payload.state?.id,
          division_id: action.payload.division?.id,
          firm_company: action.payload.firm_company,
          narration: action.payload.narration,
          cheque_no: action.payload.cheque_no,
          branch_account: action.payload.branch_account,
          customer_name: action.payload.customer_name,
          bank_account: action.payload.bank_account,
          bank_account_choice: action.payload.bank_account_choice,
          bank_account_number: action.payload.bank_account_number,
          ifsc_code: action.payload.ifsc_code,
          bank_branch: action.payload.bank_branch,
          customer_bank_name: action.payload.customer_bank_name,
          customer_bank_account: action.payload.customer_bank_account,
          customer_ifsc_code: action.payload.customer_ifsc_code,
          customer_bank_branch: action.payload.customer_bank_branch,
          payment_type: action.payload.payment_type,
          attachment: action.payload.attachment,
          items,
          deletedItems: [],
        },
      };
    },
    deleteRecord: (state) => ({ ...state, loading: false }),
    InputChangeValue: (state, action) => ({
      ...state,
      rowdata: { ...state.rowdata, [action.payload.key]: action.payload.value },
    }),
    ItemInputChangeValue: (state, action) => {
      const { index, key, value } = action.payload;
      const items = [...(state.rowdata.items || [])];
      items[index] = { ...items[index], [key]: value };
      return { ...state, rowdata: { ...state.rowdata, items } };
    },
    addItemRow: (state) => ({
      ...state,
      rowdata: { ...state.rowdata, items: [...(state.rowdata.items || []), { ...emptyItem }] },
    }),
    removeItemRow: (state, action) => {
      const removedItem = (state.rowdata.items || [])[action.payload];
      const items = (state.rowdata.items || []).filter((_, i) => i !== action.payload);
      const deletedItems = [...(state.rowdata.deletedItems || [])];
      if (removedItem?.id) {
        deletedItems.push(removedItem);
      }
      return {
        ...state,
        rowdata: { ...state.rowdata, items: items.length ? items : [{ ...emptyItem }], deletedItems },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return { ...state, model: false, rowdata: { items: [{ ...emptyItem }], deletedItems: [] } };
      }
      return { ...state, model: true };
    },
    SetParams: (state, action) => ({ ...state, params: action.payload }),
    isDrawerVisible: (state, action) => ({ ...state, drawer: action.payload }),
    fsyncStatusUpdate: (state) => ({ ...state, loading: true }),
    FilterInputChangeValue: (state, action) => ({
      ...state,
      params: { ...state.params, [action.payload.key]: action.payload.value },
    }),
    accountPaymentApproval: (state) => ({ ...state, loading: true }),
    accountPaymentApprovalSuccessful: (state) => ({ ...state, loading: false }),
    apiError: (state, action) => ({ ...state, loading: false, error_msg: action.payload }),
  },
});

export const {
  getList,
  listSuccessful,
  addRecord,
  addRecordSuccessful,
  editRecord,
  viewRecord,
  isViewModelVisible,
  deleteRecord,
  getRecordById,
  getRecordByIdSuccessful,
  InputChangeValue,
  ItemInputChangeValue,
  addItemRow,
  removeItemRow,
  isModelVisible,
  SetParams,
  isDrawerVisible,
  fsyncStatusUpdate,
  FilterInputChangeValue,
  accountPaymentApproval,
  accountPaymentApprovalSuccessful,
  apiError,
} = accountPaymentSlice.actions;

export default accountPaymentSlice.reducer;
